import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  InputGroup,
  Card,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SuperTableV2 from "../../SuperTableV2";
import { inputChange } from "../../../helpers";
import swal from "sweetalert";
import DatePicker from "react-datepicker";  
import { CalendarServices } from "./CalendarServices";
import Swal from "sweetalert2";

const createTime = (hours, minutes) => {
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(0);
  return date;
};

const defaultHours = {
  lunes: {
    start1: createTime(8, 0),
    end1: createTime(12, 0),
    start2: createTime(13, 0),
    end2: createTime(17, 0),
    start3: null,
    end3: null,
  },
  martes: {
    start1: createTime(8, 0),
    end1: createTime(12, 0),
    start2: createTime(13, 0),
    end2: createTime(17, 0),
    start3: null,
    end3: null,
  },
  miércoles: {
    start1: createTime(8, 0),
    end1: createTime(12, 0),
    start2: createTime(13, 0),
    end2: createTime(17, 0),
    start3: null,
    end3: null,
  },
  jueves: {
    start1: createTime(8, 0),
    end1: createTime(12, 0),
    start2: createTime(13, 0),
    end2: createTime(17, 0),
  },
  viernes: {
    start1: createTime(8, 0),
    end1: createTime(12, 0),
    start2: createTime(13, 0),
    end2: createTime(17, 0),
    start3: null,
    end3: null,
  },
  sábado: {
    start1: null,
    end1: null,
    start2: null,
    end2: null,
    start3: null,
    end3: null,
  },
  domingo: {
    start1: null,
    end1: null,
    start2: null,
    end2: null,
    start3: null,
    end3: null,
  },
};

const CustomCalender = ({
  loadCaledar,
  setShow,
  calendarToEdit,
  show,
  setCalendars,
}) => {
  const [calendarForm, setCalendarForm] = useState({
    title: "",
    exceptions: [],
    start: "",
    end: "",
    error: "",
    hours: defaultHours,
    exceptiondate: "",
    descripExce: "",
    new: true,
  });
  const [hours, setHours] = useState(defaultHours);
  const [loading, setLoading] = useState(false);
  const [hasLoading, setHasloading] = useState(false);
  const [hasCheck, setHasCheck] = useState(false);
  const [excDates,setExcDates] = useState([])

  // Estado con las horas de trabajo

  const resetSingleTime = (day, period) => {
    console.log(day, period);
    setHours((prev) => ({
      ...prev,
      [day]: {
        ...prev[day],
        [period]: defaultHours[day][period],
      },
    }));
  };

  const addException = () => {

    const dateForm1 = new Date(calendarForm.exceptiondate)
      .toISOString()
      .split("T")[0];
    const dateForm2 = `${dateForm1.split("-")[2]}/${dateForm1.split("-")[1]}/${
      dateForm1.split("-")[0]
    }`;

    const dateExist = calendarForm.exceptions.some((excep) => {
      return excep.date == dateForm2;
    });

    if (dateExist) {
      setCalendarForm((prev) => {
        const textError = "La fecha ya ha sido agregada como una excepción";
        return { ...prev, error: textError };
      });
      return;
    }

    if (calendarForm.exceptiondate && calendarForm.descripExce) {
      setCalendarForm((prev) => {
        console.log(prev);
        return {
          ...prev,
          exceptiondate: null,
          descripExce: "",
          error: "",
          exceptions: [
            ...prev.exceptions,
            {
              Id: null,
              date: dateForm2,
              descripcion: calendarForm.descripExce,
            },
          ],
        };
      });
    
      setExcDates((prev)=>{
        console.log(prev)
        return [...prev,calendarForm.exceptiondate]
      })
    }
  };

  const removeException = async (exceptionDelete) => {
    if (calendarForm.new) {
      setCalendarForm((prev) => {
        console.log(prev);
        return {
          ...prev,
          exceptions: prev.exceptions.filter(
            (excep) => excep.date !== exceptionDelete.date
          ),
        };
      });
    } else {
      const result = await CalendarServices.deleteException(
        calendarToEdit[0].IdCalendario,
        exceptionDelete.Id
      );
      setCalendarForm((prev) => {
        console.log(prev);
        return {
          ...prev,
          exceptions: prev.exceptions.filter(
            (excep) => excep.date !== exceptionDelete.date
          ),
        };
      });
    }
  };

  const saveCalendar = async (data) => {
    try {
      setHasloading(true);

      if (data.new) {
        const result = await CalendarServices.createCalendar(data);
        if (result.status === 200) {
          swal(
            "Guardado",
            "Su Calendario ha sido creado correctamente.",
            "success"
          ).then((value) => {
            loadCaledar();
            setShow(false);
          });
        }
      } else {
        const result = await CalendarServices.updateCalendar(
          data,
          calendarToEdit[0].IdCalendario
        );

        console.log(result);
        if (result.status === 200) {
          swal(
            "Guardado",
            "Su Calendario ha sido actualizado correctamente.",
            "success"
          ).then((value) => {
            setCalendars((prev) =>
              prev.map((calend) =>
                calend.IdCalendario === calendarToEdit[0].IdCalendario
                  ? { ...calend, Nombre: data.name }
                  : calend
              )
            );
            setShow(false);
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(calendarForm);

    const daysOfWeek = [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
    ];
    const formattedHours = Object.keys(hours).reduce((acc, day) => {
      acc[day] = {
        start1: hours[day].start1
          ? hours[day].start1
              .toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h23",
              })
              .slice(0, 5)
          : null,
        end1: hours[day].end1
          ? hours[day].end1
              .toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h23",
              })
              .slice(0, 5)
          : null,
        start2: hours[day].start2
          ? hours[day].start2
              .toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h23",
              })
              .slice(0, 5)
          : null,
        end2: hours[day].end2
          ? hours[day].end2
              .toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h23",
              })
              .slice(0, 5)
          : null,
        start3: hours[day].start3
          ? hours[day].start3
              .toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h23",
              })
              .slice(0, 5)
          : null,
        end3: hours[day].end3
          ? hours[day].end3
              .toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h23",
              })
              .slice(0, 5)
          : null,
      };
      return acc;
    }, {});

    const searchIndexOfDay = (day) => {
      return daysOfWeek.indexOf(day);
    };

    const customCalendar = {
      name: calendarForm.title,
      worktime: {
        hours: Object.keys(formattedHours).map((day) => ({
          days: [searchIndexOfDay(day)],
          intervals: formattedHours[day],
          idHours1: hours[day].IdHour1,
          idHours2: hours[day].IdHour2,
          idHours3: hours[day].IdHourr,
        })),
      },
      holidays: calendarForm.exceptions,
      new: calendarForm.new,
    };

    saveCalendar(customCalendar);
  };

  const columns = [
    {
      caption: "Fecha",
      selector: "date",
      width: 250,
    },
    {
      caption: "Descripción",
      selector: "descripcion",
      width: 250,
    },
    {
      caption: "Eliminar",
      selector: "acciones",
      width: 40,
      customRender: (row) => {
        return (
          <span>
            <i
              className="fa fa-trash cursor-pointer text-danger"
              onClick={() => {
                removeException(row.data);
              }}
            ></i>
          </span>
        );
      },
    },
  ];

  const handleTimeChange = (day, period, time) => {

    setHours((prev) => ({
      ...prev,
      [day]: {
        ...prev[day],
        [period]: time,
      },
    }));
  };
  const hoursFormate = {
    lunes: {},
    martes: {},
    miércoles: {},
    jueves: {},
    viernes: {},
    sábado: {},
    domingo: {},
  };
  const daysOfWeek = [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado",
  ];

  const loadOneCalendar = async (IdCalendar) => {
    try {
      setLoading(true);
      const result = await CalendarServices.getOneCalendar(IdCalendar);

      const hourFormat = result[2].forEach((element) => {
        const dayName = daysOfWeek[element.DiaSemana - 1];
        const startTimes = element.HoraInicio
          ? element.HoraInicio.split(",")
          : [null, null, null];
        const endTimes = element.HoraFin
          ? element.HoraFin.split(",")
          : [null, null, null];
        const idHours = element.IdHoraLaboral.split(",");
        hoursFormate[dayName].IdHour1 = idHours[0];
        hoursFormate[dayName].IdHour2 = idHours[1];
        hoursFormate[dayName].IdHour3 = idHours[2];

        if (startTimes[0]) {
          const [startHour1, startMinute1] = startTimes[0]
            .split(":")
            .map(Number);
          hoursFormate[dayName].start1 = createTime(startHour1, startMinute1);
        }
        if (startTimes[1]) {
          const [startHour2, startMinute2] = startTimes[1]
            .split(":")
            .map(Number);
          hoursFormate[dayName].start2 = createTime(startHour2, startMinute2);
        }
        if (startTimes[2]) {
          const [startHour3, startMinute3] = startTimes[2]
            .split(":")
            .map(Number);
          hoursFormate[dayName].start3 = createTime(startHour3, startMinute3);
        }
        if (endTimes[0]) {
          const [endHour1, endMinute1] = endTimes[0].split(":").map(Number);
          hoursFormate[dayName].end1 = createTime(endHour1, endMinute1);
        }
        if (endTimes[1]) {
          const [endHour2, endMinute2] = endTimes[1].split(":").map(Number);
          hoursFormate[dayName].end2 = createTime(endHour2, endMinute2);
        }
        if (endTimes[2]) {
          const [endHour3, endMinute3] = endTimes[2].split(":").map(Number);
          hoursFormate[dayName].end3 = createTime(endHour3, endMinute3);
        }
      });
      
      const datesExc = result[1].map((dat)=>{
          const datForm  = dat.date.split('/')
          const datFormEnd = new Date(datForm[2], (datForm[1] - 1),datForm[0])
          console.log(datFormEnd)
          return datFormEnd
      })
      setExcDates(datesExc)

      setCalendarForm((prev) => {
        return {
          ...prev,
          title: result[0][0].Nombre,
          exceptions: result[1],
          new: false,
        };
      });

      setHours(hoursFormate);
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (calendarToEdit) {
      loadOneCalendar(calendarToEdit[0].IdCalendario);
    }
  }, [show]);

  return (
    <div className="container mt-1">
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" variant="info" role="status" />
        </div>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Card className="mb-4">
            <Card.Body>
              <h5>Nombre del Calendario</h5>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      type="text"
                      value={calendarForm.title}
                      required
                      name="title"
                      onChange={
                        (e) => {
                          inputChange(e, setCalendarForm);
                        }
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Días Laborables */}
          <Card className="mb-4">
            <Card.Body>
              <h5 className="pb-1">
                Dias Laborables{" "}
                <small>
                  (predeterminadamente tienes dos intervalos de trabajo)
                </small>
              </h5>
              <div className="m-1">
                <Form.Check
                  type="checkbox"
                  label="Desea agregar otra Jornada Laboral?"
                  value={hasCheck}
                  onChange={(e) => {
                    setHasCheck(e.target.checked);
                  }}
                />
              </div>
              <div>
                {Object.keys(hours).map((day) => (
                  <div key={day}>
                    <h5>{day.charAt(0).toUpperCase() + day.slice(1)}</h5>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "30px",
                        alignItems: "center",
                      }}
                    >
                      <div className="d-flex flex-row-reverse">
                        <button
                          type="button"
                          className="btn-undo-calendar"
                          onClick={() => resetSingleTime(day, "start1")}
                          style={{
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                            color: "#007bff",
                            fontSize: "16px",
                          }}
                        >
                          <i className="fa fa-undo" />
                        </button>
                        <DatePicker
                          className="mr-1 calendar-width form-control"
                          selected={hours[day].start1}
                          onChange={(time) =>
                            handleTimeChange(day, "start1", time)
                          }
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={15}
                          timeCaption="Inicio"
                          dateFormat="h:mm aa"
                        />
                      </div>
                      <div className="d-flex flex-row-reverse">
                        <button
                          type="button"
                          className="btn-undo-calendar"
                          onClick={() => resetSingleTime(day, "end1")}
                          style={{
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                            color: "#007bff",
                            fontSize: "16px",
                          }}
                        >
                          <i className="fa fa-undo" />
                        </button>
                        <DatePicker
                          className="mr-1 calendar-width form-control"
                          selected={hours[day].end1}
                          onChange={(time) =>
                            handleTimeChange(day, "end1", time)
                          }
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={15}
                          timeCaption="Fin"
                          dateFormat="h:mm aa"
                        />
                      </div>
                      <div className="d-flex flex-row-reverse">
                        <button
                          type="button"
                          className="btn-undo-calendar"
                          onClick={() => resetSingleTime(day, "start2")}
                          style={{
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                            color: "#007bff",
                            fontSize: "16px",
                          }}
                        >
                          <i className="fa fa-undo" />
                        </button>
                        <DatePicker
                          className="mr-1 calendar-width form-control"
                          selected={hours[day].start2}
                          onChange={(time) =>
                            handleTimeChange(day, "start2", time)
                          }
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={15}
                          timeCaption="Inicio"
                          dateFormat="h:mm aa"
                        />
                      </div>
                      <div className="d-flex flex-row-reverse">
                        <button
                          type="button"
                          className="btn-undo-calendar"
                          onClick={() => resetSingleTime(day, "end2")}
                          style={{
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                            color: "#007bff",
                            fontSize: "16px",
                          }}
                        >
                          <i className="fa fa-undo" />
                        </button>
                        <DatePicker
                          className="mr-1 calendar-width form-control"
                          selected={hours[day].end2}
                          onChange={(time) =>
                            handleTimeChange(day, "end2", time)
                          }
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={15}
                          timeCaption="Fin"
                          dateFormat="h:mm aa"
                        />
                      </div>
                    </div>
                    {/*tercer periodo */}
                    {hasCheck && (
                      <div
                        className="mt-2"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "30px",
                          alignItems: "center",
                        }}
                      >
                        <div className="d-flex flex-row-reverse">
                          <button
                            type="button"
                            className="btn-undo-calendar"
                            onClick={() => resetSingleTime(day, "start3")}
                            style={{
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                              color: "#007bff",
                              fontSize: "16px",
                            }}
                          >
                            <i className="fa fa-undo" />
                          </button>
                          <DatePicker
                            className="mr-1 calendar-width form-control"
                            selected={hours[day].start3}
                            onChange={(time) =>
                              handleTimeChange(day, "start3", time)
                            }
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Inicio"
                            dateFormat="h:mm aa"
                          />
                        </div>
                        <div className="d-flex flex-row-reverse">
                          <button
                            type="button"
                            className="btn-undo-calendar"
                            onClick={() => resetSingleTime(day, "end3")}
                            style={{
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                              color: "#007bff",
                              fontSize: "16px",
                            }}
                          >
                            <i className="fa fa-undo" />
                          </button>
                          <DatePicker
                            className="mr-1 calendar-width form-control"
                            selected={hours[day].end3}
                            onChange={(time) =>
                              handleTimeChange(day, "end3", time)
                            }
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Fin"
                            dateFormat="h:mm aa"
                          />
                        </div>
                      </div>
                    )}

                    {/* </div> */}
                  </div>
                ))}
              </div>
            </Card.Body>
          </Card>
          <Card className="mb-4">
            <Card.Body>
              <h5>Excepciones (Días Festivos)</h5>
              <div className="d-flex">
                <InputGroup className="mb-3">
                  <ReactDatePicker
                    selected={calendarForm.exceptiondate}
                    onChange={(date) => {
                      setCalendarForm((prev) => {
                        return { ...prev, exceptiondate: date };
                      });
                    }}
                    name="exceptiondate"
                    locale="es"
                    excludeDates = {excDates}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Selecciona una fecha"
                    className="form-control"
                  />
                </InputGroup>
                <InputGroup className="mb-3">
                  <Form.Control
                    width={70}
                    type="text"
                    value={calendarForm.descripExce}
                    placeholder="Motivo de la excepción"
                    onChange={(e) => {
                      setCalendarForm((prev) => {
                        return { ...prev, descripExce: e.target.value };
                      });
                    }}
                  ></Form.Control>
                </InputGroup>
              </div>
              <Button variant="outline-secondary" onClick={addException}>
                Añadir Excepción
              </Button>
              {calendarForm.error && (
                <p className="text-danger">{calendarForm.error}</p>
              )}

              {calendarForm.exceptions.length > 0 && (
                <div style={{ maxHeight: "200px", overflowY: "scroll" }}>
                  <SuperTableV2
                    data={calendarForm.exceptions}
                    columns={columns}
                    paging
                    numberOfRows={3}
                    sortAsc
                  />
                </div>
              )}
            </Card.Body>
          </Card>
          <div className="d-flex justify-content-end">
            <Button disabled={hasLoading} variant="success" type="submit" block>
              {hasLoading ? <>Guardando....</> : <>Guardar Calendario</>}
            </Button>
          </div>
        </Form>
      )}
    </div>
  );
};

export default React.memo(CustomCalender);
